import authenticationService from '../instanceOfAuthentication'

export class AuthenticationController {
  static login = (data: { login: string; password: string; provider?: string }) => authenticationService.post('/login', data)
  static recoveryPassword = (data: { login: string }) => authenticationService.post('/recovery', data)
}
